import { render } from "./finalAcquisition.vue?vue&type=template&id=3c3ba136&scoped=true"
import script from "./finalAcquisition.vue?vue&type=script&lang=ts"
export * from "./finalAcquisition.vue?vue&type=script&lang=ts"

import "./finalAcquisition.vue?vue&type=style&index=0&id=3c3ba136&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c3ba136"

export default script